import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { DateHelper } from '../../../../../shared/helpers/date.helper';
import { ExchangeAssignmentsModalComponent } from '../../../exchange-assignments-modal/exchange-assignments-modal.component';
import { AssignmentDetailsDateModel } from '../../models/assignment-details-date.model';
import { AssignmentDetailsStateService } from '../../services/assignment-details-state.service';
import { AssignmentsHelperService } from '../../services/assignments-helper.service';
import { AssignmentCancelSubstituteSearchModalComponent } from './assignment-cancel-cancel-substitute-search-modal/assignment-cancel-substitute-search-modal.component';
import { AssignmentCancelModalComponent } from './assignment-cancel-modal/assignment-cancel-modal.component';

@Component({
    selector: 'app-assignment-information',
    templateUrl: './assignment-information.component.html',
    styleUrl: './assignment-information.component.scss'
})
export class AssignmentInformationComponent {
    @Input({ required: true }) assignmentId!: number;

    @Output() onReturn = new EventEmitter<boolean>();

    constructor(
        protected assignmentDetailsStateService: AssignmentDetailsStateService,
        private dateHelper: DateHelper,
        private bsModalService: BsModalService,
        private router: Router,
        private assignmentsHelperService: AssignmentsHelperService
    ) {
    }

    protected IsOnSameDay(assignmentDetailsModel: AssignmentDetailsDateModel | null): boolean {
        if (assignmentDetailsModel == null) return false;
        return this.dateHelper.IsOnSameDay(assignmentDetailsModel.from, assignmentDetailsModel.to);
    }

    protected openCancellationModal(): void {
        let bsModalRef = this.bsModalService.show(AssignmentCancelModalComponent, {
            ignoreBackdropClick: true,
            initialState: {
                assignmentId: this.assignmentDetailsStateService.assignmentDetails.value?.id
            }
        });

        bsModalRef.content?.onSuccess.subscribe((isSuccess: boolean) => {
            if (isSuccess) this.reloadData();
        });
    }

    public openExchangeAssignmentModal(): void {
        const currentAssignment = this.assignmentDetailsStateService.assignmentDetails.value;
        if (currentAssignment == null) return;

        const currentExchangeModel = this.assignmentsHelperService.transformDetailsToExchangeModel(currentAssignment)
        const initialState = { exchangeAssignments: [currentExchangeModel], isVacacyAllowed: true };
        const modalRef: BsModalRef = this.bsModalService.show(ExchangeAssignmentsModalComponent, {
            ignoreBackdropClick: true,
            initialState
        });

        modalRef?.content.onFullSuccess.subscribe((isSuccess: boolean) => {
            if (isSuccess) this.onReturn.emit(true);
        });
    }

    protected openCancellSubstituteSearchModal(): void {
        let bsModalRef = this.bsModalService.show(AssignmentCancelSubstituteSearchModalComponent, {
            ignoreBackdropClick: true,
            initialState: {
                assignmentId: this.assignmentDetailsStateService.assignmentDetails.value?.id
            }
        });

        bsModalRef.content?.onSuccess.subscribe((isSuccess: boolean) => {
            if (isSuccess) this.reloadData();
        });
    }

    private reloadData(): void {
        this.assignmentDetailsStateService.loadAssingmentDetails(this.assignmentId);
    }
}
